import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import UserAccessNav from '../components/UserAccessNav';
import { UserContext } from '../App';
import { listUserRegistry, UserRegistryRecord } from '../util/userAccessApi';

function UserAccessUsers() {
  const userCtx = useContext(UserContext);
  const [users, setUsers] = useState<UserRegistryRecord[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!userCtx.user) {
      return;
    }

    setLoading(true);
    setError(null);

    listUserRegistry()
      .then((response) => setUsers(response))
      .catch((e: Error) => {
        console.error('Failed to load users!', e);
        setError(e.message || 'Nepodarilo sa načítať používateľov.');
      })
      .finally(() => setLoading(false));
  }, [userCtx.user]);

  return (
    <div className="flex flex-col min-h-0 h-full">
      <Header />
      <UserAccessNav />

      <div className="flex-1 overflow-auto p-6">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <h1 className="text-2xl font-bold">Registrovaní používatelia</h1>
          {userCtx.user && (
            <Link className="btn-primary" to="/userAccessUsers/new">
              + Nový používateľ
            </Link>
          )}
        </div>

        {!userCtx.user && <div className="mt-4">Neprihlásený!</div>}
        {userCtx.user && loading && <div className="mt-4">Načítavam...</div>}
        {userCtx.user && error && <div className="mt-4 text-red-600">{error}</div>}
        {userCtx.user && !loading && !error && (
          <>
            {users.length === 0 ? (
              <div className="mt-4">Zatiaľ nie sú registrovaní žiadni používatelia.</div>
            ) : (
              <div className="mt-4 overflow-auto rounded border border-amber-200 bg-white">
                <table className="min-w-full text-left">
                  <thead className="bg-amber-100">
                    <tr>
                      <th className="p-3">User ID</th>
                      <th className="p-3">Meno</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((user) => (
                      <tr key={user.id} className="border-t border-amber-100">
                        <td className="p-3 whitespace-nowrap">
                          <Link className="text-amber-700 underline" to={`/userAccessUsers/${user.id}`}>
                            {user.userid}
                          </Link>
                        </td>
                        <td className="p-3 whitespace-nowrap">{user.name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default UserAccessUsers;
